/**
 * Подписи к enum из rnis_emulator_v2_subscriptions (бэкенд).
 */
export class RnisEmulatorLabels {

    static subscriptionStatusLabel(status: string): string {
        return this.statusText[status] || status;
    }

    static subscriptionStatusColor(status: string): string {
        return this.statusColor[status] || 'grey';
    }

    static timeOfDayLabel(timeOfDay: string): string {
        return this.timeOfDayText[timeOfDay] || timeOfDay;
    }
    private static statusText: Record<string, string> = {
        CREATED: 'Создана',
        ACTIVE: 'Активна',
        SUSPENDED: 'Приостановлена',
        EXPIRED: 'Истекла',
        DEACTIVATED: 'Деактивирована',
    };

    private static statusColor: Record<string, string> = {
        CREATED: 'blue-grey',
        ACTIVE: 'success',
        SUSPENDED: 'warning',
        EXPIRED: 'grey',
        DEACTIVATED: 'error',
    };

    private static timeOfDayText: Record<string, string> = {
        DAY: 'День',
        NIGHT: 'Ночь',
    };
}
